import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGGREGATED_STARTS_AUGUST_GRADIENT_LEGEND } from '../../../constants/legends';

// Выбор года вынесен на таймлайн внизу карты (AggStartsAugustYearTimeline).
// Здесь остаётся только легенда.
const AggStartsFilterComponent = () => (
    <div>
        <LegendRenderer config={AGGREGATED_STARTS_AUGUST_GRADIENT_LEGEND} />
    </div>
);

export const AggStartsAugustFilter = withDisplayedLayersCheck(
    AggStartsFilterComponent,
    t`Агрегированные старты (август)`
);
